import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-pix-receive-payment-professional-resume',
	templateUrl: './resume.component.html',
	styleUrls: ['./resume.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixReceivePaymentResumeComponent implements OnInit {

	constructor(private router: Router) {}

	ngOnInit(): void {
	}

	generate() {
		this.router.navigate(['pix/receber/qr-code']);
	}

	goBack() {
		this.router.navigate(['pix/receber']);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/receive-payment/resume/resume.component.ts